// OnboardingStepV3 — single row inside the 3-step stepper.
//
// - Completed step → green check with muted body
// - Active step   → blue outline + `aria-current="step"`
// - Idle step     → dim number badge
import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, Circle, ArrowUpRight } from "lucide-react";

export default function OnboardingStepV3({
    idx,
    testId,
    completed,
    active,
    title,
    subtitle,
    href,
}) {
    const bodyClass = completed ? "text-[#CCCCCC]" : "text-[#FFFFFF]";
    const badgeStyle = completed
        ? { backgroundColor: "#FFFFFF", color: "#0A0A0A" }
        : active
            ? { backgroundColor: "rgba(255, 255, 255,0.15)", color: "#FFFFFF", border: "1px solid #FFFFFF" }
            : { backgroundColor: "#1A1A1A", color: "#71717A" };

    const numberBadge = (
        <span
            className="inline-flex items-center justify-center w-8 h-8 rounded-full text-sm font-semibold tabular-nums shrink-0"
            style={badgeStyle}
            aria-hidden
        >
            {completed ? <CheckCircle2 className="w-4.5 h-4.5" /> : idx + 1}
        </span>
    );

    const inner = (
        <div className="flex items-start gap-3 flex-1 min-w-0">
            {numberBadge}
            <div className="flex-1 min-w-0">
                <p className={`text-sm font-medium ${bodyClass}`}>{title}</p>
                {subtitle && <p className="mt-0.5 text-xs text-[#CCCCCC] truncate">{subtitle}</p>}
            </div>
            {!completed && href && (
                <ArrowUpRight className="w-4 h-4 text-[#CCCCCC] group-hover:text-[#FFFFFF] transition-colors" />
            )}
            {completed && <Circle className="w-4 h-4 text-transparent" aria-hidden />}
        </div>
    );

    const commonProps = {
        "data-testid": testId,
        "aria-current": active ? "step" : undefined,
        "aria-label": `${title}${completed ? " — completato" : ""}`,
        className: `group flex items-center gap-3 rounded-xl px-3 py-2.5 transition-colors ${
            !completed && href ? "hover:bg-white/[0.03] cursor-pointer" : ""
        }`,
    };

    if (completed || !href) {
        return <div {...commonProps}>{inner}</div>;
    }
    return (
        <Link to={href} {...commonProps} style={{ textDecoration: "none" }}>
            {inner}
        </Link>
    );
}
